/* ---------------------------------------------------------------------
 *                           Import Packages
 * --------------------------------------------------------------------- */

// React
import React from "react";

// React DOM
import ReactDOM from "react-dom/client";

// React路由
import { RouterProvider, createBrowserRouter } from "react-router-dom";

// React组件
import Root, {
  loader as rootLoader,
  action as rootAction,
} from "./components/root/Root";
import Home from "./components/home/Home";
import Login from "./components/login/Login";
import {
  loader as authLoader,
  action as authAction,
} from "./components/login/Login";
import Error from "./components/error/Error";

/* --------------------------------------------------------------------
 *                         Main react router
 * --------------------------------------------------------------------*/

/**
 * 定义路由
 * @returns {object} - 路由对象
 */
const router = createBrowserRouter([
  {
    // 登录页
    path: "/login",
    element: <Login />,
    errorElement: <Error />,
    loader: authLoader,
    action: authAction,
  },
  {
    path: "/",
    element: <Root />,
    loader: rootLoader,
    action: rootAction,
    children: [
      // 首页
      {
        index: true,
        element: <Home />,
      },
      // 错误页
      {
        path: "error",
        element: <Error />,
      },
    ],
  },
]);

/* ---------------------------------------------------------------------
 *                           Initialize app
 * --------------------------------------------------------------------- */

// 初始化App
const root = ReactDOM.createRoot(document.getElementById("root"));

// 渲染App
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
